export enum AttachType {
    Rid = 1,
    CartaIdentita = 2,
    Fattura = 3,
    ContrattoCartaceo = 4,
    IvaAgevolata = 5,
    DichiarazioneImposte = 6,
    DatiCatastali = 7,
    Deroga = 8,
    LetteraAccettazione = 9,
    Addendum = 10,
    DichiarazioneIntento = 11,
    DichiarazioneImposteEsclusi = 12,
    DichiarazioneImposteEsenti = 13,
    Recesso = 14,
    Pratiche333 = 15,
    AllegatoGenerico = 16,
    CodiceFiscale = 17,
    Patente = 18,
    RegistrazionePreAdesione = 19,
    RegistrazioneAdesione = 20,
    ChiamataVerifica = 21,
    AllegatiRegistrazionePreAdesione = 22,
    AllegatiRegistrazioneAdesione = 23,
    SmsTeleselling = 24,
    VocalOrder = 25,
    Delega = 26,
    ServizioUltimaIstanza = 27,
    LegittimaOccupazione = 28,
    RichiestaFornitura = 1000,
    CondizioniEconomiche = 1001,
    AgevolazioneAccise = 1003,
    FileAudioFirma = 1004,
    UltimaBolletta = 1005,
    VisuraCamerale = 1006,
    Passaporto = 1007,
    RiconoscimentoGenerico = 1008,
    CartaIdentitaElettronica = 1009
}



// WEBPACK FOOTER //
// ./src/app/models/request-and-responses/rest-api/enums/attachType.ts